import { render, staticRenderFns } from "./AgencyBankInfoAdd.vue?vue&type=template&id=4853c1cc&scoped=true&"
import script from "./AgencyBankInfoAdd.vue?vue&type=script&lang=js&"
export * from "./AgencyBankInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./AgencyBankInfoAdd.vue?vue&type=style&index=0&id=4853c1cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853c1cc",
  null
  
)

export default component.exports